import React from 'react';
import { useJobs } from '../contexts/JobContext';
import { Loader2, X } from 'lucide-react';

export const GlobalJobTicker = () => {
    const { activeJobs } = useJobs();

    if (!activeJobs || activeJobs.length === 0) return null;

    return (
        <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
            {activeJobs.map(job => (
                <div key={job.job_id} className="relative group bg-indigo-600 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 w-80 text-sm">
                    <Loader2 className="w-5 h-5 animate-spin flex-shrink-0" />
                    <div className="flex-1">
                        <div className="font-semibold">Importación en progreso</div>
                        <div className="opacity-90">{job.processed} de {job.total} expedientes</div>
                    </div>
                    <button
                        onClick={() => setActiveJobs(prev => prev.filter(j => j.job_id !== job.job_id))}
                        className="absolute -top-2 -right-2 bg-gray-800 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity border border-gray-700"
                        title="Descartar notificación"
                    >
                        <X className="w-3 h-3" />
                    </button>
                </div>
            ))}
        </div>
    );
};
